export default "__VITE_ASSET__53b0ea40__"